import { Divider, Skeleton } from '@mui/material';
import { Box } from '@mui/system';

interface ILocationDetailsSkeleton {
  boxesNum?: number;
  isLoading: boolean;
  children: JSX.Element;
  topSlider?: boolean;
  length?: number;
}

const LocationDetailsSkeleton = ({ isLoading, children, length, boxesNum,
  topSlider = false }: ILocationDetailsSkeleton) => {
  return (
    <>
      {isLoading ?
        <Box display='flex' justifyContent='flex-start'
          flexDirection='column' m={2}>
          <Skeleton width='100%' height='50px'
            sx={{ mt: 2 }} />
          <Divider sx={{ mt: 2, mb: 2, width: '100%' }} />
          {topSlider && 
          <Box display='flex' justifyContent='space-evenly'> 
            {[...Array(boxesNum)].map((_, index) => (
              <Box key={index} m={1}>
                <Skeleton variant='rectangular' width='250px'
                  height='200px' sx={{borderRadius: '20px'}}/>
              </Box>
            ))}
          </Box>}
          {/* {topSlider &&
            <Skeleton variant='rectangular'
              width='1000px'
              height='500px'
              sx={{ borderRadius: '20px', minHeight: '500px', maxWidth: '1000px', maxHeight: '500px', margin: '0 auto' }}
            />} */}

          {/* <Box mx={10} mt={5}
            display='flex'
            justifyContent='flex-start'
            columnGap={25}>
            <LinesSkeleton lines={16} />
            <Skeleton variant='rectangular' width='100%'
              height='auto' sx={{ borderRadius: '3px', maxHeight: '253px' }} />
          </Box> */}
          {[...Array(length)].map((_, key) => {
            return (
              <>
                <Box key={key} >
                  <Skeleton variant='rectangular'
                    width='100%'
                    height='300px'
                    sx={{ borderRadius: '20px', mt: 5}}/>
                </Box>
              </>
            );
          })
          } 
        </Box>
        : children
      }
    </>
  );
};

export default LocationDetailsSkeleton;